import { Table2, Grid2x2 } from 'lucide-react';
import { ViewMode } from '../../utils/viewModeUtils/viewMode';
import IconButton from './IconButton';
import { ViewModeConstants } from '../../constants/ViewModeConstants';

export function ViewToggle({
    view,
    toggle,
}: { view: ViewMode; toggle: () => void }) {
    return (
        <IconButton
            label={view === ViewModeConstants.DATA_CARDS ? 'List View' : 'Card View'}
            color="orange"
            icon={view === ViewModeConstants.DATA_CARDS ? <Table2 /> : <Grid2x2 />}
            onClick={toggle} />
    );
}